import React from "react";
import ResearchMenu from "../components/menu/general/ResearchMenu";

const TabelPenelitian = () => {
  return <ResearchMenu />;
};
export default TabelPenelitian;
